module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/General/Star-73e46e7e0e0123508cdf5e42ac558969d3c3ce531a2adcb9fc81d0ea5753dbee.svg";